<template>
  <v-layout v-if="labelMode">
    {{ Number(realCost).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
    &nbsp;
    <span class="ml-1" v-html="displayCurrencyLabel"></span>
    <span v-if="displayMetricLabel">/{{ displayMetricLabel }}</span>
  </v-layout>
  <div v-else
  class="crx-input mod-parent">
    <span
    v-if="debugMode"
    class="red--text" 
    style="position:absolute;font-size:10px;top:0;">
      {{ realCost }}
    </span>
    <input
    v-model="localQuantity"
    spellcheck="false"
    ref="input"
    @focus="onFocus"
    @blur="localFocussed = false"
    />

    <v-menu
    offset-y
    min-width="200"
    :disabled="allowedMetrics.length < 2"
    left>

      <template v-slot:activator="{ on }">
        <span 
        v-on="on"
        class="caption span-no-wrap ml-1">
          <span class="mr-1 ml-1" v-html="displayCurrencyLabel"></span>
          <span v-if="displayMetricLabel">/{{ displayMetricLabel }}</span>
          <v-icon v-if="allowedMetrics.length > 1">mdi-menu-down</v-icon>
        </span>
      </template>

      <v-card>
        <v-list>
          <v-subheader>
            Unit price is quoted in
          </v-subheader>
          <div class="c-hr"></div>
          <v-list-item
          v-for="allowedMetric in allowedMetrics" :key="allowedMetric"
          @click="displayMetric = allowedMetric">
            {{ getMetricName(allowedMetric) }}
          </v-list-item>
        </v-list>
      </v-card>

    </v-menu>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    metric: 0, // This must be the inventory definitions DEFAULT (unchanging) metric
    definition: {
      default: null
    },
    realCost: {
      default: 0
    },
    currencyLabel: {
      default: '?'
    },
    labelMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localFocussed: false,
      localQuantity: 0,
      displayMetric: 0
    }
  },
  computed: {
    ...mapGetters({
      defaultCurrency: 'db/currencies/getDefaultCurrency'
    }),
    debugMode () {
      return this.$store.state.settings.debugMode
    },
    automaticLocalQuantity () {
      return new BigNumber(this.localQuantity).dividedBy(this.ratio).toNumber()
    },
    allowedMetrics () {
      var allowedMetrics = []
      if (this.definition) {
        allowedMetrics.push(this.definition.metric)
        if (this.definition.volume > 0) {
          allowedMetrics.push(1)
        }
        if (this.definition.mass > 0) {
          allowedMetrics.push(2)
        }
        allowedMetrics = this.$codash.arrayUnique(allowedMetrics)
      }
      return allowedMetrics
    },
    displayCurrencyLabel () {
      if (this.currencyLabel === 'EUR') {
        return '&euro;'
      }
      return this.currencyLabel // this.defaultCurrency.symbol
    },
    displayMetricLabel () {
      var label = this.getMetricSymbol(this.displayMetric)
      if (label === 'unit') {
        return null
      }
      return label
    },
    ratio () {
      if (this.definition) {
        if (this.definition.metric !== this.displayMetric) {
          var sids = ['si-units-units', 'si-vol-l', 'si-mass-kg', 'si-len-m']
          var sidNative = sids[this.definition.metric]
          var sidCurrent = sids[this.displayMetric]
          var ratio = this.$crx.metrics.getConversionRatioFromSids(sidCurrent, sidNative, this.definition)
          // var ratio = this.$crx.metrics.getConversionRatio(this.definition.metric, displayMetric, this.definition)
          /* switch (displayMetric) {
            case 0:
              ratio *= 1
              break
            case 1:
              // ml - litres
              ratio /= 1000
              break
            case 2:
              // mg - kg
              ratio /= (1000 * 1000)
              break
            case 3:
              ratio /= 1000
              break
          } */
          return ratio
        }
      }
      return 1
    }
  },
  watch: {
    definition: {
      immediate: true,
      handler (nv) {
        if (nv) { // could be undefined or (null?)
          // set the display metric to the definitions default metric on update
          this.displayMetric = nv.metric
        }
      }
    },
    /* metric (nv) {
      this.localQuantity = this.realCost * this.ratio
    }, */
    localFocussed (nv) {
      this.$emit('update:focussed', nv)
    },
    realCost (nv) {
      if (!this.localFocussed) {
        var newQuantity = nv * this.ratio
        this.localQuantity = newQuantity
      }
    },
    automaticLocalQuantity (nv) {
      var diff = new BigNumber(Math.abs(nv)).minus(Math.abs(this.realCost)).abs()
      if (diff.isGreaterThan(0.00001)) {
        console.log(typeof nv)
        this.$emit('update:realCost', nv)
      }
    },
    localQuantity (nv) {
      /* if (this.localFocussed) {
        var newCost = new BigNumber(nv).dividedBy(this.ratio)
        this.$emit('update:realCost', newCost)
      } */
    }
  },
  methods: {
    getMetricName (metric) {
      if (metric === 0) {
        return 'unit'
      } else if (metric === 1) {
        return 'litres'
      } else if (metric === 2) {
        return 'kilograms'
      } else if (metric === 3) {
        return 'metres'
      }
    },
    getMetricSymbol (metric) {
      if (metric === 0) {
        return 'unit'
      } else if (metric === 1) {
        return 'l'
      } else if (metric === 2) {
        return 'kg'
      } else if (metric === 3) {
        return 'm'
      }
    },
    onFocus (event) {
      event.target.select()
      this.localFocussed = true
    }
  },
  created () {
    this.localQuantity = this.realCost * this.ratio
  }
}
</script>

<style scoped>
.span-no-wrap {
  white-space: nowrap;
}
.mod-parent {
  flex-direction: row;
  align-items: baseline;
}
.crx-input input {
  text-align: left;
}
.crx-input:focus-within input {
  text-align: left;
}
</style>
